<template>
  <b-card>
<b-card :header="caption">

  <div id="cover" style="position: fixed; height: 100%; width: 100%; top:0; left: 0; background: rgba(255, 255, 255, 0.8); z-index:9999;">
    <div style="background-color:white;position: absolute; margin: auto; top: 0; right: 0; bottom: 0; left: 0; width: 200px; height: 30px; border-radius: 3px;">
      <img class="navbar-brand-full" src="/static/img/preload.gif">
    </div>
  </div>
  <nav class="navbar navbar-light bg-light justify-content-between" style="margin-bottom: 10px;background-color:rgb(51, 103, 103) !important;">
    <a class="navbar-brand"> </a>
    <form class="form-inline">
      <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search" v-model="searchTerm" :state="searchLocks">
    </form>
  </nav>

  <b-row>
    <b-col sm="6" lg="3" v-for="nextItem in items" :key="nextItem.id">
      <lock-card :nextItem=nextItem></lock-card>
    </b-col>
    <b-col sm="12" lg="12">
      <b-card v-if="items.length == 0">
        <div class="alert alert-danger">
          <ul class="fa-ul" style="margin-bottom: 0px;">
            <li>
              <i class="fa fa-info-circle fa-li"></i>
              No locks found.
            </li>
          </ul>
        </div>
      </b-card>
    </b-col>
  </b-row>
</b-card>
</b-card>
</template>

<script>

import LockCard from '@/views/base/haus/LockCard'

let qs = require('qs')
const constants = require('./shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
//const API = BASE + '/api/locks/list'
const API_ASSIGN_LOCK_TO_LOCATION = BASE + '/api/locks/assignLocation'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken,
      'authorization': data.accessToken
    },
    method: 'POST'
  }).then(res => res.json())
}

// async function getData () {
//   let param = {
//     client_id: constants.NEWPORT_CONST.CLIENT_ID,
//     client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
//     accessToken: localStorage.getItem('token')
//   }
//   let res = await postdata(API, param)
//   document.getElementById('cover').style.display = 'none'
//   return res.locks
// }

async function filterItems (needle, heystack) {
  var query = needle.toLowerCase()
  return heystack.filter(function (item) {
    let name = item.lockName.toLowerCase().indexOf(query) >= 0
    let alias = item.lockAlias.toLowerCase().indexOf(query) >= 0
    if (name || alias) return true
    else return false
  })
}

export default {
  name: 'Locks',
  components: {
    LockCard
  },
  props: {
    caption: {
      type: String,
      default: 'Locks List'
    }
  },
  data: () => {
    return {
      locations: [],
      searchTerm: '',
      items: [],
      itemsFull: [],
      fields: [{
        key: 'check'
      },
      {
        key: 'lockId'
      },
      {
        key: 'lockAlias'
      },
      {
        key: 'lockName'
      },
      {
        key: 'lockMac'
      },
      {
        key: 'action'
      },
      {
        key: 'locationId'
      },
      {
        key: 'location'
      }
      ],
      currentPage: 1,
      perPage: 25,
      totalRows: 0,
      filter: null,
      selected: [],
      selectAll: false
    }
  },
  computed: {
    searchLocks () {
      var needle = this.$data.searchTerm
      if (needle.length > 1) {
        filterItems(needle, this.$data.itemsFull).then(dataList => {
          this.$data.items = dataList
        })
      } else {
        this.$data.items = this.$data.itemsFull
      }
    }
  },
  mounted () {

    let localLocksList = localStorage.getItem('localLocksList')

      if(localLocksList === null || localLocksList === 'undefined') {
        constants.gotoLogin()
      } else {
        this.$data.itemsFull = JSON.parse(localLocksList)
        this.$data.items = JSON.parse(localLocksList)
        document.getElementById('cover').style.display = 'none'
      }

    // getData().then(response => {
    //   this.$data.itemsFull = response
    //   this.$data.items = response
    // })
    this.$root.$on('locks', (locks) => {
      this.items = locks
    })
  },
  methods: {
    getRowCount (items) {
      return items.length
    },
    openlink (link) {
      location.href = link
    },
    assignToLocation (lockId, idx) {
      let parameters = {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        lockId: lockId,
        locationId: localStorage.getItem('locationId')
      }
      postdata(API_ASSIGN_LOCK_TO_LOCATION, parameters)
        .then(data => {
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
      this.$data.items.splice(idx, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/Locks.vue